import React from "react";

import { getContactLink, goTo, useGetPracticeCrops, useTranslation } from "utils";

import { Link, StepType, StepsWidget, Typography } from "components";

interface FootprintingStepsProps {
  farmId: string;
  cropIds: string[];
  dairy: boolean;
  currentStep: number;
  year?: number;
  isLoading?: boolean;
}

export const FootprintingReviewSteps = ({ currentStep, year, isLoading, cropIds, dairy }: FootprintingStepsProps) => {
  const { t } = useTranslation("footprinting");
  const allCropsQuery = useGetPracticeCrops({ enabled: true });

  const steps: StepType[] = [
    {
      title: <Typography variant="paragraph-m">{t("reviewAndSubmit.reviewFarm")}</Typography>,
    },
    ...cropIds.map((cropId) => ({
      title: (
        <Typography variant="paragraph-m">
          {t("reviewAndSubmit.reviewCrop")} {allCropsQuery.data?.find((c) => c.id === cropId)?.name}
        </Typography>
      ),
    })),
    dairy
      ? {
          title: <Typography variant="paragraph-m">{`${t("reviewAndSubmit.reviewCrop")} Dairy`}</Typography>,
        }
      : null,
    {
      title: <Typography variant="paragraph-m">{t("reviewAndSubmit.submitForVerification")}</Typography>,
    },
  ].filter((s) => s !== null);

  return (
    <StepsWidget
      className="review-and-submit-steps"
      subtitle={t("reviewAndSubmit.CO₂Footprint", { year })}
      title={t("reviewAndSubmit.title")}
      description={t("reviewAndSubmit.description")}
      steps={steps}
      currentStep={currentStep}
      direction="vertical"
      isLoading={isLoading || allCropsQuery.isLoading}
    >
      <Typography variant="paragraph-m">
        {t("reviewAndSubmit.support")}
        <Link className="margin-left-25" onClick={(e) => goTo(e, null, getContactLink(), true)}>
          {t("reviewAndSubmit.contact")}
        </Link>
      </Typography>
    </StepsWidget>
  );
};
